'use client';

import { usePathname, useSearchParams } from 'next/navigation';

import Links from '~/lib/helpers/link-helper';

import Pill from '../pill';

import styles from '~/styles/components/product/product-tags.module.scss';
import { mapQueryBy, mapSortBy } from 'sdk';
import { Box } from '../layout/box';
import Text from '../typography/text';
import AccordionWrapper from '../accordion/wrapper';
import AccordionHeaderWrapper from '../accordion/header-wrapper';
import AccordionContentWrapper from '../accordion/content-wrapper';

export default function DescriptionTags({
  subConditionMap,
  subConditions,
  title,
}: {
  subConditionMap: any;
  subConditions: any;
  title: string;
}) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // Create a flattened array of tags
  const tags = [
    ...(subConditions?.filter(
      (condition) =>
        !subConditionMap || !Object.keys(subConditionMap).includes(condition)
    ) || []),
    ...(subConditionMap
      ? Object.entries(subConditionMap).map(([key, values]) =>
          Array.isArray(values) && values.length > 0
            ? `${key}: ${values.join(', ')}`
            : key
        )
      : []),
  ];

  if (!tags || tags.length < 1) return null;

  return (
    <AccordionWrapper>
      <AccordionHeaderWrapper>
        <Box>
          <Text size="large" font="bold">
            {title || 'Tags'}
          </Text>
        </Box>
      </AccordionHeaderWrapper>
      <AccordionContentWrapper>
        <div className={styles.tags}>
          <div className={styles['tags-container']}>
            {tags.map((tag, i) => (
              <span key={`${tag}-${i}`} className={styles['tags-pill']}>
                <Pill
                  text={tag}
                  link={{
                    href: Links.searchWithQueryAppRouter({
                      pathname,
                      searchParams,
                      options: {
                        index: 'books',
                        params: {
                          q: '*',
                          sort_by: mapSortBy('books'),
                          query_by: mapQueryBy('books'),
                          filter_by: `condition_attributes:${tag}`,
                        },
                        options: {},
                      },
                      path: '/search',
                    }).url,
                  }}
                />
              </span>
            ))}
          </div>
        </div>
      </AccordionContentWrapper>
    </AccordionWrapper>
  );
}
